import React, { Fragment, useEffect, useReducer, useRef } from 'react';
import ScrollContainer from "./ScrollContainer";
import { useSelector } from "react-redux";
import ProductItem from "./ProductItem";


/**
 * @param {Object} props
 * @param {Object} props.responsiveConfig - Configuration object for responsive behavior
 * @param {boolean} [props.checkForParentMiniCart=false] - Whether to check for parent mini cart
 * @param {string|null} [props.parentClass=null] - Parent class name
 * @param {string|null} [props.heading=null] - Heading text
 * @param {boolean} [props.openMiniCartAtCheckout=true] - Whether to open mini cart on the checkout page or not
 * @return {void}
 */
const Upsell = function({
    responsiveConfig,
    checkForParentMiniCart = false,
    parentClass = null,
    heading = null,
    openMiniCartAtCheckout= true
}) {
    /**
     * @type ProductItem[]
     */
    const cart = useSelector(state => state.checkout);
    const upsellProducts= useSelector(state => state.cart.upsellProducts);
    const intervalRef = useRef(0);
    const [ignored, forceUpdate] = useReducer(x => x + 1, 0, () => {});

    const intervalCheck = () => {
        const miniCartHidden = document.querySelector('#mini-cart .mini-cart-content');
        if (miniCartHidden.offsetWidth > 0) {
            forceUpdate();
        }
    }

    useEffect(() => {
        intervalRef.current = setInterval(intervalCheck, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);

    if (!upsellProducts || !upsellProducts.length) return null;
    
    return <div className={parentClass}>
        <ScrollContainer {...{ responsiveConfig, heading, ignored }}>
            {upsellProducts.map((productItem) =>
                <Fragment key={productItem.systemId}>
                    <ProductItem {...{ productItem, openMiniCartAtCheckout }}/>
                </Fragment>
            )}
        </ScrollContainer>
    </div>
}

export default Upsell;
